import React, { useMemo } from 'react';
import SourceListCard from '../SourceListCard/SourceListCard';

interface SourceListProps {
	sourcesByParam: any[];
	isCardColumnView?: boolean;
	disabledList?: boolean;
	enabledAnnotation?: boolean;
	resetAnnotationIcon?: boolean;
	onAnnotationToggle?: (isActive: boolean, sourceKey?: string, sourceSerialNumber?: string) => void;
	activeAnnotationIcon?: string | null;
}

const SourceList: React.FC<SourceListProps> = ({ sourcesByParam = [], isCardColumnView = false, disabledList = false, enabledAnnotation = false, resetAnnotationIcon = false, onAnnotationToggle = () => {}, activeAnnotationIcon = null }) => {
	
	// Use useMemo to force complete re-render when sourcesByParam changes
	// This ensures proper cleanup of removed cards
	const renderedCards = useMemo(() => {
		if (sourcesByParam.length === 0) {
			return null;
		}
		return sourcesByParam.map((source, index) => {
			// Check if this parameter's sources should be disabled based on whether any source is checked
			// const hasCheckedSources = source?.sources?.some((src: any) => src.checked) || false;
			const shouldDisableCard = disabledList;
			const cardKey = `source-${source.id}`;
			
			return (
				<SourceListCard
					key={cardKey}
					title={source.name}
					percentage={source.health || 0}
					sources={source.sources || []}
					isColumnView={isCardColumnView}
					disabledCard={shouldDisableCard}
					enabledAnnotation={enabledAnnotation}
					resetAnnotationIcon={resetAnnotationIcon}
					onAnnotationToggle={onAnnotationToggle}
					activeAnnotationIcon={activeAnnotationIcon}
				/>
			);
		});
	}, [sourcesByParam, isCardColumnView, disabledList, enabledAnnotation, resetAnnotationIcon, activeAnnotationIcon]);
	
	return renderedCards;
};

export default SourceList;
